/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import typography from '../../typography';
import borders from '../../borders';

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from '../../../functions/pxToRem';

const { fontWeightBold, size } = typography;
const { borderRadius } = borders;

export default {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: size.md,
    lineHeight: 1.25,
    fontWeight: fontWeightBold,
    borderRadius: borderRadius.md,
    padding: `${pxToRem(12)} ${pxToRem(24)}`,
    textAlign: 'center',
    textTransform: 'none',
    userSelect: 'none',
    backgroundSize: '150% !important',
    backgroundPositionX: '25% !important',
    transition: `all 150ms ease-in !important`, // !important is here because otherwise LoadingButton's transition gets overriden

    '&:hover': {
        transform: 'scale(1.02)',
    },

    '&:disabled': {
        pointerEvent: 'none',
        opacity: '0.7 !important',
    },

    '& .material-icons': {
        fontSize: pxToRem(15),
        marginTop: pxToRem(-2),
    },

    '&.MuiButton-sizeMedium .MuiLoadingButton-loadingIndicator .MuiCircularProgress-root':
        {
            height: '20px !important',
            width: '20px !important',
        },
    '&.MuiButton-sizeLarge .MuiLoadingButton-loadingIndicator .MuiCircularProgress-root':
        {
            height: '24px !important',
            width: '24px !important',
        },

    '.MuiButton-startIcon': {
        marginLeft: '-4px',
        marginRight: '8px',
    },
    '.MuiButton-endIcon': {
        marginLeft: '4px',
        marginRight: '-4px',
    },
};
